
    import styled from 'styled-components';

    const NAVIGATION_BAR_HEIGHT = 52;

    // -----------
    //  SVGs
    // -----------

    export const CNNBadgeSVG = ({ className, ...props }) =>
        <svg className={ className } width="100%" height="100%" viewBox="0 0 1002.5 1002.5">
            <rect x="0" y="0" fill="#CC0000" width="1002.5" height="1002.5"/>
            <path fill="#FFFFFF" d="M838.2,321.1v293.4c0,12.2-7.7,22.5-19.1,25.6c-2.1,0.6-4.4,0.9-6.7,0.9c-8.6,0-18.6-4.3-25.7-16.4
                c-0.4-0.7-29.2-50.3-73-125.9c-31.7-54.6-64.4-111-65-112c-3.5-6-8.3-8.8-12.9-7.6c-2.9,0.8-6.2,3.6-6.2,8.9v226.5
                c0,12.2-7.7,22.5-19.1,25.6c-9.7,2.6-23.4,0-32.5-15.5c-0.4-0.6-27.1-46.8-67.9-117.1c-34.2-58.9-69.5-119.8-70.1-120.8
                c-3.5-6-8.4-8.9-13-7.6c-2.9,0.8-6.3,3.6-6.3,8.9l0,221.6c0,15.2-13.4,28.6-28.7,28.6H279.5c-75.5,0-136.9-61.4-136.9-136.9
                c0-75.5,61.4-136.9,136.9-136.9H338v-43.3h-58.4c-99.5,0-180.2,80.7-180.2,180.2c0,99.5,80.7,180.2,180.2,180.2h113.6
                c43.2,0,70.9-25.3,70.9-71.9V506.7c0,0,72.4,124.8,75.8,130.4c46,78.1,132.9,45.8,132.9-21.4v-109c0,0,72.4,124.8,75.8,130.4
                c46,78.1,132.9,45.8,132.9-21.4V321.1H838.2z"/>
            <path fill="#FFFFFF" d="M203.6,501.3c0-42.2,34.2-76.4,76.4-76.4H338v-43.3h-58.4c-66,0-119.6,53.7-119.6,119.6
                c0,66,53.7,119.6,119.6,119.6H392c6.3,0,11.3-6.2,11.3-11.3V388c0-12.2,7.7-22.5,19.1-25.6c9.7-2.6,23.4,0,32.5,15.5
                c0.4,0.7,28.1,48.3,70.2,120.9c33,57,67.2,115.9,67.9,117c3.5,6,8.4,8.9,13,7.6c2.9-0.8,6.3-3.6,6.3-8.9V388
                c0-12.2,7.6-22.5,19-25.6c9.7-2.6,23.2,0.1,32.3,15.5c0.4,0.7,24.8,42.8,65,112.1c35.5,61.3,72.3,124.7,73,125.8
                c3.5,6,8.4,8.9,13,7.6c2.9-0.8,6.3-3.6,6.3-8.9V321.1h-43.4v174.7c0,0-72.4-124.8-75.8-130.4c-46-78.1-132.9-45.8-132.9,21.4v109
                c0,0-72.4-124.8-75.8-130.4c-46-78.1-132.9-45.8-132.9,21.4v178.7c0,6.5-4.9,12.2-12,12.2H280C237.8,577.6,203.6,543.4,203.6,501.3z"/>
        </svg>

    export const AccountIconFill = ({ className, onClick, ...props }) =>
        <svg className={ className } width="24" height="24" 
                viewBox="0 0 64 64" tabIndex="0" focusable="true"
                xmlns="https://www.w3.org/2000/svg" 
                aria-labelledby="userFillIconTitle" role="img" onClick={onClick}>
            <title id="userFillIconTitle">User Account</title>
            <path fillRule="evenodd" d="M54.3,48.5c-0.1-0.7-0.4-1.3-0.8-1.8c-1.7-3.4-8.2-6.4-18.3-7.1c7.3-2,11.5-9.4,9.4-16.7 c-0.1-0.5-0.3-1.1-0.5-1.6c-1.3-3.3-3.9-5.9-7.2-7.2c-6.8-2.9-14.8,0.3-17.7,7.3s0.3,14.8,7.3,17.7c0.5,0.2,1.1,0.4,1.6,0.5 c-10,0.7-16.5,3.7-18.1,7.1c-0.3,0.4-0.4,1-0.7,1.4c-4.9-6.8-6.4-15.7-4-24c2.4-8.8,9.1-15.7,17.8-18.4c14.5-5,30.3,2.7,35.3,17.2 C61.4,31.6,59.9,41.1,54.3,48.5 M22.9,1.3C12.5,4.2,4.2,12.5,1.3,22.9C-2.1,34.4,1.2,46.8,9.9,55l0,0l0.1,0.1 c8.4,8,20.3,10.8,31.3,7.5c10.4-3,18.4-11.2,21.4-21.6c5-17-4.8-34.8-21.8-39.8C35-0.4,28.7-0.4,22.9,1.3"></path>
        </svg>

    export const AccountIconOutline = ({ className, onClick, ...props }) =>
        <svg className={ className } width="24" height="24" 
                viewBox="0 0 64 64" tabIndex="0" focusable="true"
                xmlns="https://www.w3.org/2000/svg" 
                aria-labelledby="userIconTitle" role="img" onClick={onClick}>
            <title id="userIconTitle">User Account</title>
            <path fillRule="evenodd" d="M32,59.7c-7.9,0-15.5-3.4-20.7-9.3c0.8-1.5,2-2.7,3.4-3.5c4.2-2.5,10.4-3.9,16.9-3.9s12.6,1.4,16.9,3.9 c1.7,0.9,3,2.3,3.6,4.1C47,56.5,39.6,59.7,32,59.7 M36.9,36.7c-5.1,2.9-11.6,1.1-14.5-4c-1.8-3.3-1.8-7.2,0-10.4 c0.9-1.7,2.3-3.3,4.1-4.1c5.2-2.8,11.7-0.9,14.5,4.3c1.7,3.1,1.7,7.1,0,10.2C40,34.4,38.6,35.8,36.9,36.7 M42.3,6.2 c7.5,2.7,13.3,8.8,15.8,16.3c2.9,8.2,1.8,17.5-3,24.8c-1.1-1.7-2.6-3.1-4.3-4.1c-3.3-1.8-6.8-3-10.5-3.7c4.9-3.4,7.3-9.3,6.1-15.2 c-1.2-6-6-10.5-11.9-11.5c-8-1.5-15.8,3.7-17.4,11.7c-1.1,5.9,1.3,11.7,6.2,15.1c-3.7,0.7-7.4,1.8-10.6,3.7 c-1.5,0.9-2.9,2.1-3.9,3.5C5.7,42.3,4.3,37.2,4.3,32C4.3,13.5,22.8-1,42.3,6.2 M42.6,1.8C25.9-4,7.6,4.8,1.8,21.5 c-2.4,6.8-2.4,14.3,0,21.2c3,9.2,10.3,16.5,19.5,19.5c16.7,5.9,35-2.9,40.9-19.7c2.4-6.8,2.4-14.3,0-21.2 C59.2,12.1,52,4.9,42.6,1.8"></path>
        </svg>

    export const TwitterIcon = ({ className, onClick, ...props }) =>
        <a className={ "cnnix--nav__share-btn twitter" } target="_blank" data-service="twitter" onClick={ onClick }>
            <svg width="30px" height="30px" preserveAspectRatio="xMaxYMax" viewBox="50 50 400 400" enableBackground="new 0 0 400 400">
                <path fill="#FFFFFF" d="M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"></path>
            </svg>
        </a>

    export const FacebookIcon = ({ className, onClick, ...props }) =>
        <a className={ "cnnix--nav__share-btn facebook" } target="_blank" data-service="facebook" onClick={ onClick }>
            <svg width="30px" height="30px" viewBox="50 50 400 400" enableBackground="new 0 0 400 400">
                <path fill="#FFFFFF" d="M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"></path>
            </svg>
        </a>

    export const ListElement = ({ className, text, onClick, ...props }) =>
        <li className={ className } dangerouslySetInnerHTML={{ __html: text }} onClick={ onClick } />


    // -----------
    //  Styles
    // -----------

    export const CNNBadge = styled(CNNBadgeSVG)`
        display: block;
        position: relative;
        flex: 0 0 auto;
        
        width: ${ NAVIGATION_BAR_HEIGHT }px;
        height: ${ NAVIGATION_BAR_HEIGHT }px;
        margin-right: 2px;
        text-decoration: none;
        margin-right: 8px;

        @media screen and (min-width: 800px)
        {
            margin-left: 5px;
        }
    `;

    export const Spacer = styled.div`
        display: block;
        flex: 1 1 auto;
        height: 100%;
        width: 100%;
    `;

    export const Content = styled.div`
        display: flex;
        flex-direction: row;
        /* max-width: 980px; */
        max-width: 1100px;
        height: 100%;
        width: 100%;
        margin: 0 auto;
        flex: 0 0 auto;
    `;

    export const Bar = styled.div`
        display: block;
        position: relative;
        background: black;
        flex: 0 0 auto;
        height: ${ NAVIGATION_BAR_HEIGHT }px;
        width: 100%;

        z-index: 2;
    `;

    export const Nav = styled.div`
        display: flex;
        position: sticky;
        visibility: visible !important;
        flex-direction: column;

        font-family: CNN Condensed;

        color: white;
        width: 100%;
        top: 0px;

        z-index: 99;
    `;

    export const ToolBar = styled.div`
        display: flex;
        flex: 0 0 auto;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 10px;

        .cnnix--nav__share-btn
        {
            cursor: pointer;
            display: flex;
            margin-right: 5px;
        }
    `;

    export const ShareBar = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
    `;

    export const Twitter = styled(TwitterIcon)`

    `;

    export const Facebook = styled(FacebookIcon)`

    `;

    export const UserToolBar = styled.div`
        
        display: flex;
        position: relative;
        font-family: CNN;
        font-size: ${14/16}rem;

        flex-direction: row;
        justify-content: center;
        align-content: center;
        padding: 10px;
    `;

    export const LoginBtn = styled.div`        
        cursor: pointer;
        display: flex;
        font-family: CNN;
        font-size: ${14/16}rem;
        flex-direction: row;
    `;

    export const UserBtn = styled.div`        
        display: flex;
        font-family: CNN;
        font-size: ${14/16}rem;
        flex-direction: row;
    `;

    export const AccountLoggedOut = styled(AccountIconOutline)`
        cursor: pointer;
        fill: rgb(230, 230, 230);
        outline: 0px;

        &:hover
        {
            fill: rgb(255, 255, 255);
        }
    `;

    export const AccountLoggedIn = styled(AccountIconFill)`
        cursor: pointer;
        fill: rgb(230, 230, 230);
        outline: 0px;
        
        &:hover
        {
            fill: rgb(255, 255, 255);
        }
    `;


    // -----------------
    //  Account Options
    // -----------------

    export const AccountOptions = styled.div`
        display: block;
        position: absolute;

        background: ${({theme}) => theme.white};
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        right: 12px;
        top: 45px;
        
        &:after
        {
            content: "";
            width: 0px;
            height: 0px;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid rgb(254, 254, 254);
            position: absolute;
            top: -5px;
            right: 5px;
        }
    `;

    export const OptionsList = styled.ul`
        display: flex;
        flex-direction: column;
        margin: 10px 0;
        padding: 0;
    `;

    export const OptionsItem = styled(ListElement)`
        cursor: pointer;
        user-select: none;
        display: block;
        padding: 0px 30px;
        font-size: ${12/16}rem;
        line-height: 2;
        color: rgb(140, 140, 140);
        text-decoration: none;

        &:hover
        {
            color: rgb(77, 77, 77);
            background: rgb(230, 230, 230);
            text-decoration: none;
        }
    `;
